export function setSsrQueryParams({
	isSsr,
	hash,
	payload,
}: {
	isSsr: boolean | undefined
	hash: string
	payload: Record<string, string>
}) {
	if (!isSsr) {
		return
	}

	const reloadFlag = 'reloadFlag'
	const url = new URL(window.location.href)
	const hasReloaded = url.searchParams.get(reloadFlag) === '1'

	if (hasReloaded) {
		return
	}

	const livePreviewHash = 'livePreviewHash'

	for (const [key, value] of Object.entries(payload)) {
		if (key !== 'windowType' && value !== undefined) {
			const paramKey = key === 'branch' ? 'csBranch' : key
			url.searchParams.set(paramKey, String(value))
		}
	}
	url.searchParams.set(livePreviewHash, hash)
	url.searchParams.set(reloadFlag, '1')
	window.location.href = url.toString()
}
